import AbstractProvidedClass from "../../shared/AbstractProvidedClass";

export default class RectangleHorizontalBorder extends AbstractProvidedClass {
    defaultTolerance = this.mobile ? 12 : 7;

    constructor(provider, parent, corner1, corner2) {
        super(provider);
        this.parent = parent;
        this.corner1 = corner1;
        this.corner2 = corner2;
    }

    setOpposite(border) {
        this.opposite = border;
    }

    hovered(viewX, viewY) {
        return this.currentMinX <= viewX
            && this.currentMaxX >= viewX
            && this.currentMinY <= viewY
            && this.currentMaxY >= viewY;
    }

    drag() {
        this.updatePositions();
        this.updateParent();
    }

    updatePositions() {
        let absdY;
        if (this.parent.rotation == 0) {
            // No rotation
            // Mouse Y minus the actual Y of the border
            absdY = this.view.snappedAbsY - (this.parent.center.absY + this.corner1.absY);
        } else if (Math.abs(this.parent.rotation) == this.p.PI) {
            // Half rotation
            // Calculating the border Y by taking the center minus the the corner Y because it's flipped
            absdY = (this.parent.center.absY - this.corner1.absY) - this.view.snappedAbsY;
        } else if (this.parent.rotation == -this.p.HALF_PI) {
            // Quarter rotation back
            // Because of quarter turn the border is actually on the X-axis. So we calculate from the X coordinates of the mouse and center. But the border distance is still on the Y-axis relative to the rotation.
            absdY = this.view.snappedAbsX - (this.parent.center.absX + this.corner1.absY);
        } else if (this.parent.rotation == this.p.HALF_PI) {
            // Quarter rotation forward
            absdY = (this.parent.center.absX - this.corner1.absY) - this.view.snappedAbsX;
        } else {
            // Custom rotation
            let [viewX, viewY] = this.view.getRelative(this.parent.center.currentX, this.parent.center.currentY, this.parent.rotation); // Relative yPosition of the mouse to the center of the element

            let absY = viewY / this.view.scale; // Raw yPosition of the mouse in the image
            absdY = (absY - this.corner1.absY); // The difference between the mouse position and the border position
        }
        this.corner1.absY += absdY; // Move the border
        this.corner2.absY += absdY; // Move the border
        let avgY = (this.corner1.absY + this.opposite.corner1.absY) / 2; // The average yPosition of the two borders (the new center of the element)

        // Update the center of the element
        this.parent.absX += avgY * Math.cos(this.parent.rotation + Math.PI / 2);
        this.parent.absY += avgY * Math.sin(this.parent.rotation + Math.PI / 2);
    }

    updateParent() {
        // Update the corners with the new relative positions
        this.parent.updateCorners();

        this.getTab('info').input.height.value(this.calculatePixelToDisplayDistance(this.parent.height));
    }

    move(dx, dy) {
        if (dy == 0) {
            return;
        }
        this.corner1.absY += dy;
        this.corner2.absY += dy;
        this.parent.center.absY += dy / 2;
        this.getTab('info').input.height.value(this.calculatePixelToDisplayDistance(this.parent.height));
    }

    mouseOver(viewX, viewY) {
        if (!this.hovered(viewX, viewY)) {
            return false;
        }

        this.cursor.resizeVertical(this.parent.rotation);
        return true;
    }

    get absY() {
        return this.corner1.absY;
    }

    get currentMinY() {
        return this.corner1.currentY - this.tolerance;
    }

    get currentMaxY() {
        return this.corner1.currentY + this.tolerance;
    }

    get currentMinX() {
        return Math.min(this.corner1.currentX, this.corner2.currentX);
    }

    get currentMaxX() {
        return Math.max(this.corner1.currentX, this.corner2.currentX);
    }

    get tolerance() {
        return Math.min(this.defaultTolerance, this.parent.currentHeight / 10)
    }
}
